import React from 'react';
import { MessagingView } from '../../../components/shared/MessagingView';
export const Inquiries = () => {
  return <MessagingView type="seller" data-id="element-1400" />;
};